// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","container":"_3QBeRxAd_LxvLv8rjaFigc _15-uIrn7gODHiOpUuDWjwC","dataLoaded":"_3-foZLJ28brTubeHWDvYck","spinner":"_39x1D5qBf5pTJhm4Flxg6u"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/Home.css
// module id = 955
// module chunks = 1